import { cn } from '~/lib/utils';
import React, { type ReactNode } from 'react';

const SIZE = {
  default: '',
  xl: 'text-xl',
  lg: 'text-lg',
  md: 'text-md',
  sm: 'text-sm',
  label: 'text-label',
} as const;

const VARIANTS = {
  default: '',
  primary: 'font-aspekta',
  secondary: 'font-spaceMono uppercase',
} as const;

type SizeOption = keyof typeof SIZE;
type VariantOption = keyof typeof VARIANTS;

export const Text = ({
  className,
  as: Tag = 'p',
  color = 'default',
  size = 'default',
  children,
  variant = 'default',
}: {
  className?: string;
  size?: SizeOption;
  // @TODO: will type this once we update to TS 5
  as?: any;
  color?: 'default' | 'secondary';
  children: ReactNode;
  variant?: VariantOption;
}) => {
  const classSize = size && Object.keys(SIZE).includes(size) ? SIZE[size as SizeOption] : null;
  const varantClass = VARIANTS[variant as VariantOption];

  return (
    <Tag
      className={cn(classSize, varantClass, { 'text-foreground-secondary': color === 'secondary' }, 'mb-5', className)}
    >
      {children}
    </Tag>
  );
};
